import {inject} from '@angular/core';
import {CanActivateChildFn, CanActivateFn, Router} from '@angular/router';
import {of, switchMap} from 'rxjs';
import {AuthService} from '@shared/services/auth.service';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const auth: AuthService = inject(AuthService);

    // Check the authentication status
    return auth.isSignedIn().pipe(
        switchMap((authenticatedUser) => {
            console.log('checking if user signed in');

            // ❌ Nicht angemeldet → Weiterleitung zur Login-Seite
            if (!authenticatedUser) {
                const redirectURL = state.url === '/abmelden' ? '' : `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`anmelden?${redirectURL}`);
                return of(urlTree);
            }

            // ❌ Nicht verifiziert → aber nur weiterleiten, wenn nicht schon auf dieser Seite
            console.log("state url is ", state?.url)
            const creationTime = new Date(authenticatedUser?.metadata?.creationTime || '');
            const thresholdDate = new Date('2025-11-16T00:00:00Z');
            if (!authenticatedUser.emailVerified && !['/confirmation-required', '/willkommen'].includes(state?.url) && creationTime > thresholdDate) {
                console.log('user is not verified', authenticatedUser, authenticatedUser.emailVerified, state.url);
                return of(router.parseUrl('/confirmation-required'));
            }

            // ✅ Zugriff erlaubt
            return of(true);
        }),
    );
};
